import { defineComponent as H, computed as c, ref as U, createElementBlock as j, openBlock as y, createVNode as s, withCtx as i, createElementVNode as x, createBlock as C, unref as u, toDisplayString as D, createTextVNode as N } from "vue";
import { ScalarCodeBlock as T, ScalarCombobox as W, ScalarButton as z, ScalarIcon as I } from "@scalar/components";
import { snippetz as O } from "@scalar/snippetz";
import R from "../../../components/DataTable/DataTable.vue.js";
import q from "../../../components/DataTable/DataTableRow.vue.js";
import M from "../../../components/ViewLayout/ViewLayoutCollapse.vue.js";
import P from "../../Components/CodeSnippet/CodeSnippet.vue.js";
import { useWorkspace as A } from "../../../store/store.js";
const F = { class: "w-full" }, G = { class: "flex flex-1" }, J = { class: "bg-b-1 flex items-center justify-center overflow-hidden border-t" }, le = /* @__PURE__ */ H({
  __name: "RequestCodeExample",
  props: {
    collection: {},
    example: {},
    operation: {},
    server: {},
    workspace: {},
    environment: {}
  },
  setup(o) {
    var K, b, h, S;
    const { securitySchemes: k, workspaceMutators: w } = A(), f = c(() => {
      var e, t, l;
      return m.value.targetKey === "custom" && ((e = d.value) == null ? void 0 : e.some(
        (n) => n.lang === m.value.clientKey
      )) ? m.value : {
        targetKey: ((t = o.workspace.selectedHttpClient) == null ? void 0 : t.targetKey) ?? "js",
        clientKey: ((l = o.workspace.selectedHttpClient) == null ? void 0 : l.clientKey) ?? "fetch"
      };
    }), d = c(
      () => o.operation["x-codeSamples"] || o.operation["x-code-samples"] || o.operation["x-custom-examples"]
    ), m = U(
      (K = d.value) != null && K.length ? {
        targetKey: "custom",
        clientKey: (b = d.value[0]) == null ? void 0 : b.lang
      } : {
        targetKey: ((h = o.workspace.selectedHttpClient) == null ? void 0 : h.targetKey) ?? "js",
        clientKey: ((S = o.workspace.selectedHttpClient) == null ? void 0 : S.clientKey) ?? "fetch"
      }
    ), $ = c(() => (o.operation.selectedSecuritySchemeUids || o.collection.selectedSecuritySchemeUids || []).flat().map((t) => k[t]).filter((t) => !!t)), v = c(() => {
      const e = {}, t = O().clients().map((n) => ({
        label: n.title,
        options: n.clients.map((p) => (e[`${n.key},${p.client}`] = p.title, {
          id: `${n.key},${p.client}`,
          label: p.title
        }))
      })), l = (o.operation["x-codeSamples"] || o.operation["x-code-samples"] || o.operation["x-custom-examples"] || []).map((n) => ({
        id: `custom,${n.lang}`,
        label: n.label || n.lang
      })), a = l.length > 0 ? [
        {
          id: "customExamples",
          label: "Code Examples",
          options: l.map((n) => ({
            id: n.id,
            label: n.label ?? n.id
          }))
        },
        ...t
      ] : t;
      return l.forEach((n) => {
        e[n.id] = n.label ?? n.id;
      }), {
        options: a,
        dict: e
      };
    }), r = c(() => {
      const e = f.value;
      if (e.targetKey === "custom") {
        const l = `custom,${e.clientKey}`;
        return {
          id: l,
          label: v.value.dict[l] ?? "Unknown"
        };
      }
      const t = `${e.targetKey},${e.clientKey}`;
      return {
        id: t,
        label: v.value.dict[t] ?? "Unknown"
      };
    }), E = c(
      () => f.value.targetKey
    ), B = c(
      () => f.value.clientKey
    ), V = (e) => {
      if (!e)
        return;
      const { id: t } = e, [l, a] = t.split(",");
      !l || !a || (m.value = {
        targetKey: l,
        clientKey: a
      }, l !== "custom" && w.edit(o.workspace.uid, "selectedHttpClient", {
        targetKey: l,
        clientKey: a
      }));
    }, g = c(() => {
      var l;
      if (!r.value.id.startsWith("custom,"))
        return;
      const e = r.value.id.split(",")[1], t = (l = d.value) == null ? void 0 : l.find((a) => a.lang === e);
      return t == null ? void 0 : t.source;
    });
    return (e, t) => (y(), j("div", F, [
      s(M, {
        class: "group/preview w-full border-b-0",
        defaultOpen: !1
      }, {
        title: i(() => t[0] || (t[0] = [
          N("Code Snippet")
        ])),
        actions: i(() => [
          x("div", G, [
            s(u(W), {
              modelValue: r.value,
              options: v.value.options,
              placement: "bottom-end",
              "onUpdate:modelValue": V
            }, {
              default: i(() => [
                s(u(z), {
                  class: "text-c-2 hover:text-c-1 flex h-full w-fit gap-1.5 px-1.25 py-0.75 font-normal",
                  fullWidth: "",
                  variant: "ghost"
                }, {
                  default: i(() => {
                    var l;
                    return [
                      x("span", null, D((l = r.value) == null ? void 0 : l.label), 1),
                      s(u(I), {
                        icon: "ChevronDown",
                        size: "md"
                      })
                    ];
                  }),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ])
        ]),
        default: i(() => [
          s(R, {
            columns: [""],
            presentational: ""
          }, {
            default: i(() => [
              s(q, null, {
                default: i(() => [
                  x("div", J, [
                    g.value ? (y(), C(u(T), {
                      key: 0,
                      content: g.value,
                      lang: r.value.id.split(",")[1] ?? "plaintext"
                    }, null, 8, ["content", "lang"])) : (y(), C(u(P), {
                      key: 1,
                      client: B.value,
                      example: e.example,
                      operation: e.operation,
                      securitySchemes: $.value,
                      server: e.server,
                      target: E.value,
                      environment: e.environment
                    }, null, 8, ["client", "example", "operation", "securitySchemes", "server", "target", "environment"]))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]));
  }
});
export {
  le as default
};
